module.exports = __webpack_public_path__ + "resources/img/img_coolfilter7_m.fbd735c14b6a245681f348aaf0c5910f.png";